
import { Button } from '../ui/button'
import { OhButton } from '../ui/custom-radix-components/button';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from '../ui/custom-radix-components/drawer';

export default function MobileLayout({ handleCustomize, handleRejectAll, handleAcceptAll, isOpen, onClose, setIsOpen }) {
  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        if (!open) onClose();
      }}
    >
      <DrawerContent className='bg-oh-black/80 backdrop-blur-md  p-4 border-none '>
        <DrawerHeader className='py-3 mt-2 text-start'>
          <DrawerTitle className='font-semibold text-lg text-white'>
            Cookies Settings
          </DrawerTitle>
        </DrawerHeader>
        <div>
          <p className='text-white text-sm mb-2 leading-relaxed'>
            We use cookies on this site to enhance your user experience.
          </p>
          <br />
          <p className='text-white text-sm mb-6 leading-relaxed'>
            For a complete overview of all cookies used, please visit your{" "}
            <button
              onClick={handleCustomize}
              className='text-white underline  transition-colors'
            >
              personal settings
            </button>
            .
          </p>

          <div className='flex flex-col gap-2 mb-4'>

            <Button
              onClick={handleRejectAll}
              variant='outline'
              className='w-full bg-white text-oh-black hover:bg-gray-800 hover:text-white'
            >
              Reject All
            </Button>
            <OhButton
              onClick={handleAcceptAll}
              className='w-full'
            >
              Accept All
            </OhButton>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
